import React, { useRef, useState } from "react";
import { SpeakerHigh, SpeakerSlash, MagicWand, WhatsappLogo } from "@phosphor-icons/react";
import { waLink } from "../lib/api";

const WA = waLink("¡Hola Ciudad Garaje! Quiero pedir la Cerveza Potter Porter ⚡");

export const PotterVideo = () => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const v = ref.current;
    v.muted = !muted;
    if (muted) { v.currentTime = 0; v.play().catch(() => {}); }
    setMuted(!muted);
  };

  return (
    <section className="relative overflow-hidden bg-[#0a0d16] border-y border-[#C9A24B]/30" data-testid="potter-video-section">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,rgba(201,162,75,0.18),transparent_60%)]" />
      <div className="relative max-w-6xl mx-auto px-5 md:px-8 py-12 md:py-16 flex flex-col md:flex-row items-center gap-10 md:gap-16">
        <div className="relative shrink-0 w-[240px] md:w-[300px] aspect-[9/16] border border-[#C9A24B]/50 shadow-2xl shadow-black/70 overflow-hidden">
          <video ref={ref} src="/potter.mp4" poster="/potter-poster.jpg" autoPlay muted loop playsInline className="w-full h-full object-cover" data-testid="potter-video" />
          <button
            onClick={toggleSound}
            className="absolute bottom-2 right-2 h-9 px-2.5 flex items-center gap-2 bg-black/70 border border-white/20 text-white text-[11px] uppercase tracking-wider hover:bg-[#8a6d2b] transition-colors"
            aria-label={muted ? "Activar sonido" : "Silenciar"}
            data-testid="potter-sound-toggle"
          >
            {muted ? <><SpeakerSlash size={16} weight="bold" /> Activa la magia</> : <SpeakerHigh size={16} weight="bold" />}
          </button>
        </div>
        <div className="flex-1 text-center md:text-left">
          <div className="overline text-[#E8C979] mb-3 flex items-center justify-center md:justify-start gap-2"><MagicWand size={14} weight="bold" /> Edición limitada · GARAJE</div>
          <h2 className="font-display text-5xl md:text-7xl leading-none text-[#F3E3BF]" data-testid="potter-title">Cerveza Potter</h2>
          <p className="font-display text-2xl md:text-3xl text-[#C9A24B] mt-2">Porter negra con un toque de magia</p>
          <p className="text-gray-400 text-sm md:text-base mt-5 max-w-xl mx-auto md:mx-0">
            Unos lentes redondos, una varita y un hechizo: notas a chocolate, caramelo y malta tostada en una Porter artesanal suave y con cuerpo. Edición limitada, hasta agotar existencia.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 mt-8">
            <div className="font-display text-4xl text-white" data-testid="potter-price">$9.00</div>
            <a href={WA} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-7 py-3 bg-[#25D366] hover:bg-[#1ebe5b] text-black font-semibold uppercase tracking-wider text-sm transition-colors" data-testid="potter-whatsapp">
              <WhatsappLogo size={20} weight="fill" /> Pídela por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
